import { IApplicationState } from '../../types/redux';

export const selectPayment = (state: IApplicationState) => state.payment;
